import HttpService from "@/utils/httpData"
// import { APP_CONFIG } from '@/utils/constants'

export const apiGetBaseInfo = (params = {}) => {
    let apiEndpoint = `Home/GetBaseInfo`;
    return HttpService.get(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const apiCreateExam = (params = {}) => {
    let apiEndpoint = `Exam/Create`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const apiGetListClassOfTeacher = (params = {}) => {
    let apiEndpoint = `Exam/GetListClassOfTeacher`;
    return HttpService.get(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const apiGetListSubjectOfTeacher = (params = {}) => {
    let apiEndpoint = `Exam/GetListSubjectOfTeacher`;
    return HttpService.get(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const apiCreateQuestion = (params = {}) => {
    let apiEndpoint = `Question/Create`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res && res.data && !res.data.errors && res.data.data ? res.data.data : null;
    }).catch(e => { return false });
}
export const apiUpdateExam = (params = {}) => {
    let apiEndpoint = `Exam/Update`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res && res.data && !res.data.errors && res.data.data ? res.data.data : null;
    }).catch(e => { return false });
}
export const apiGetDetailQuestion = (id) => {
    let apiEndpoint = `Question/detail`;
    return HttpService.get(apiEndpoint, { id }).then(res => {
        return res && res.data && !res.data.errors && res.data.data ? res.data.data : null;
    }).catch(e => { return false });
}
export const apiDetailExam = (examId) => {
    let apiEndpoint = `Exam/Detail`;
    return HttpService.get(apiEndpoint, { examId }).then(res => {
        return res && res.data && !res.data.errors && res.data.data ? res.data.data : null;
    }).catch(e => { return false });
}
export const apiUpdateQuestion = (params = {}) => {
    let apiEndpoint = `Question/Update`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const apiGetListChooseQuestion = (params = {}) => {
    let apiEndpoint = `Exam/GetListChooseQuestion`;
    return HttpService.get(apiEndpoint, params).then(res => {
        return res && res.data && !res.data.errors && res.data.data ? res.data.data : null;
    }).catch(e => { return false });
}
export const getBook = (params = {}) => {
    let apiEndpoint = `practice/GetBook`;
    return HttpService.get(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const getCategoriesByBook= (params = {}) => {
    let apiEndpoint = `practice/get-book-index`;
    return HttpService.get(apiEndpoint,params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const apiGetListQuestionByBookIndexId= (id, keyword = '') => {
    let apiEndpoint = `Question/GetListQuestionByBookIndexId?bookIndexId=${id}&keyword=${keyword}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const apiQuestionDelete= id => {
    let apiEndpoint = `Question/Delete`;
    return HttpService.post(apiEndpoint, {id}).then(res => {
        return res && res.data && !res.data.errors && res.data.data ? res.data.data : null;
    }).catch(e => { return false });
}
export const apiExamDelete= (params = {}) => {
    let apiEndpoint = `Exam/Delete`;
    return HttpService.post(apiEndpoint,params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const getListChapterOtherPractice= (params = {}) => {
    let apiEndpoint = `Exam/GetListChapterOtherPractice`;
    return HttpService.post(apiEndpoint,params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const apiGetListQuestionByChapterId= (params = {}) => {
    let apiEndpoint = `Question/GetListQuestionOtherPracticeById`;
    return HttpService.get(apiEndpoint,params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const apiGetQuestionSampleByChapter = (params) => {
    // params: {chapterId, examId, keyword}
    let apiEndpoint = `Question/GetListQuestionByChapterExamId`;
    return HttpService.get(apiEndpoint,params).then(res => {
        return res && res.data && !res.data.errors && res.data.data ? res.data.data : null;
    }).catch(e => { return false });
}
// export const apiGetQuestionSampleByExam = (params) => {
//     console.log('params params',params);
//     // params: {chapterId, examId, keyword}
//     let apiEndpoint = `Question/GetListQuestionOtherPracticeById`;
//     return HttpService.get(apiEndpoint,params).then(res => {
//         return res && res.data && !res.data.errors && res.data.data ? res.data.data : null;
//     }).catch(e => { return false });
// }

export const apiDownloadExamPdf = (payload) => {
    // params: {chapterId, examId, keyword}
    let apiEndpoint = `exam/DownloadExamHTML`;
    return HttpService.post(apiEndpoint, payload).then(res => {
        return res && res.data && !res.data.errors && res.data.data ? res.data.data : null;
    }).catch(e => { return false });
}
